import { IiXRHrData } from '@clients/ek/interfaces';
import { IUserAvatar } from './avatar';
import { IMytaverseFile } from './file';
import { IProfileState } from './profile';
import ParticipantScopes from '@constants/scopes';

export interface IUser {
  chatImage: string;
  confirmedEmail: number;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  id: string;
  profileImage: IMytaverseFile;
  showContactInfo?: string;
  userId?: string;
  company?: string;
  phoneNumber?: string;
  linkedIn?: string;
  isTermsAccepted?: boolean;
  isAvatarTermsAccepted: boolean | null;
  hrData: IiXRHrData;
  customAvatarUrl?: string; // could we remove this?
  feedbackCompleted?: boolean;
  activeAvatarId?: string;
  lastDevicesCheckTime?: string;
  state?: IProfileState | null;
  roles?: string[];
  avatars: IUserAvatar[];
  scopes?: ParticipantScopes[];
  roleScopes?: { roleName: string; permissions: ParticipantScopes[] }[];
  isMultiRole?: boolean;
}

export interface ILogoutForced {
  reason: LogoutReasonEnum;
  messageCode: string;
}

export enum LogoutReasonEnum {
  UNAUTHORISED = 'UNAUTHORISED',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SUPPORT = 'SUPPORT',
}
